import { BinaryWriter } from "../binary.js";
import { ClientOp, ServerOp } from "../opcodes.js";
/**
 * Lista de amigos e guildas (PRD §6).
 *
 * As duas moram no mesmo pacote porque respondem à mesma pergunta — **quem está online e
 * quem é meu** — e porque a resposta muda pelos mesmos eventos: alguém entrou, alguém saiu,
 * alguém foi aceito. Dois pacotes obrigariam o servidor a mandar os dois toda vez que
 * qualquer um mudasse, que é o mesmo tráfego com o dobro de código.
 *
 * A presença atravessa instâncias pelo barramento Redis (PRD §3.3): quem está no processo
 * ao lado aparece online do mesmo jeito, e é essa transparência que faz "lista de amigos"
 * significar alguma coisa num mundo dividido em nodes.
 */
export const SocialAction = {
    /** Pede a lista inteira. O cliente manda ao entrar. */
    Refresh: 0,
    AddFriend: 1,
    RemoveFriend: 2,
    /** Cria a guilda. `name` é o nome dela. */
    GuildCreate: 3,
    /** Convida. `name` é o personagem. */
    GuildInvite: 4,
    /** Aceita o convite pendente. */
    GuildAccept: 5,
    /** Sai da guilda. O líder que sai a dissolve. */
    GuildLeave: 6,
    /** Expulsa. Só o líder. */
    GuildKick: 7,
};
export function isSocialAction(value) {
    return value >= 0 && value <= 7;
}
export function encodeSocialRequest(packet, writer = new BinaryWriter(64)) {
    writer.u8(ClientOp.Social).u8(packet.action).str8(packet.name);
    return writer;
}
export function decodeSocialRequest(reader) {
    const rawAction = reader.u8();
    return {
        action: isSocialAction(rawAction) ? rawAction : SocialAction.Refresh,
        name: reader.str8(),
    };
}
export const GuildRank = {
    Member: 0,
    Leader: 1,
};
export function encodeSocial(packet, writer = new BinaryWriter(256)) {
    writer.u8(ServerOp.Social).str8(packet.guild).str8(packet.invite);
    writeEntries(writer, packet.friends);
    writeEntries(writer, packet.members);
    return writer;
}
export function decodeSocial(reader) {
    return {
        guild: reader.str8(),
        invite: reader.str8(),
        friends: readEntries(reader),
        members: readEntries(reader),
    };
}
/** Teto de linhas por lista, para o `u8` de contagem não estourar sem aviso. */
export const MAX_SOCIAL_ENTRIES = 255;
function writeEntries(writer, entries) {
    const capped = entries.slice(0, MAX_SOCIAL_ENTRIES);
    writer.u8(capped.length);
    for (const entry of capped) {
        writer.str8(entry.name).u8(entry.online ? 1 : 0).u8(entry.rank);
    }
}
function readEntries(reader) {
    const count = reader.u8();
    const entries = new Array(count);
    for (let i = 0; i < count; i++) {
        entries[i] = {
            name: reader.str8(),
            online: reader.u8() !== 0,
            rank: reader.u8() === GuildRank.Leader ? GuildRank.Leader : GuildRank.Member,
        };
    }
    return entries;
}
//# sourceMappingURL=social.js.map